import React from 'react';
import { connect } from 'react-redux';

import { RootMenuItem } from '../../types';
import { ReduxState } from 'app/redux/types';

import { Spinner } from 'app/design-system/components/Spinner';
import { useTranslation } from 'app/lang';

import RootMenuItems from '../../components/RootMenuItems';
import {
  entityLoading,
  matchIds,
  rootMenuItems,
} from '../../selectors/live';

import dictionary from './RootMenu.dictionary.json';

import styles from '../../styles/LeftMenu.module.scss';

type LiveRootMenuProps = {
  loading: boolean;
  items: RootMenuItem[];
};

const LiveRootMenu: React.FC<LiveRootMenuProps> = ({ loading, items }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.root}>
      <div className={styles.header}
           data-test="root-menu-header">
        {t(dictionary.header)}
      </div>

      <div className={styles.body}>
        {loading
          ? <Spinner size={40} />
          : <RootMenuItems list={items} />
        }
      </div>
    </div>
  );
};

const mapStateToProps = (state: ReduxState): LiveRootMenuProps => {
  return ({
    loading: entityLoading(state) && matchIds(state).size <= 0,
    items: rootMenuItems(state),
  });
};

export default connect(mapStateToProps)(LiveRootMenu);
